import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap";

// The New course modal on the Courses index and Templates tab (TMS-1586): Blank
// course or From template → template picker → confirm (name + carry-over
// checklist). `open` starts at the first step; `useTemplate` (a Templates tab row)
// jumps straight to the confirm step for that template, so Back closes the modal.
// It sits on the page root, since the triggers live outside the modal.
export default class extends Controller {
  static targets = ["modal", "title", "step", "form", "search", "template", "noMatches", "templateTitle", "nameInput", "back"];
  static values = {
    baseUrl: String
  };

  open(event) {
    event.preventDefault();
    this.fromPicker = true;
    this.showStep("choose");
    this.show();
  }

  useTemplate(event) {
    event.preventDefault();
    this.fromPicker = false;
    this.confirm(event.currentTarget.dataset);
    this.show();
  }

  showPicker() {
    this.showStep("pick");
    if (this.hasSearchTarget) this.searchTarget.focus();
  }

  choose(event) {
    this.confirm(event.currentTarget.dataset);
    this.nameInputTarget.focus();
    this.nameInputTarget.select();
  }

  back() {
    if (this.fromPicker) {
      this.showPicker();
    } else {
      Modal.getOrCreateInstance(this.modalTarget).hide();
    }
  }

  filter() {
    const query = this.searchTarget.value.trim().toLowerCase();
    let visible = 0;

    this.templateTargets.forEach((template) => {
      const match = !query || template.dataset.search.includes(query);
      template.hidden = !match;
      if (match) visible += 1;
    });

    if (this.hasNoMatchesTarget) this.noMatchesTarget.hidden = visible > 0;
  }

  modalHidden() {
    this.showStep("choose");
    this.nameInputTarget.value = "";
    if (this.hasSearchTarget) {
      this.searchTarget.value = "";
      this.filter();
    }
  }

  confirm({ templateId, templateTitle }) {
    this.formTarget.action = this.baseUrlValue.replace(":id", templateId);
    this.templateTitleTarget.textContent = templateTitle;
    this.nameInputTarget.value = templateTitle;
    this.showStep("confirm");
  }

  showStep(step) {
    this.stepTargets.forEach((element) => { element.hidden = element.dataset.step !== step; });
    this.formTarget.hidden = step !== "confirm";
    this.titleTarget.textContent = {
      choose: "New course",
      pick: "Choose a template",
      confirm: "New course from template"
    }[step];
  }

  show() {
    const modal = Modal.getOrCreateInstance(this.modalTarget);
    modal.show();

    if (!this.formTarget.hidden) {
      this.modalTarget.addEventListener("shown.bs.modal", () => {
        this.nameInputTarget.focus();
        this.nameInputTarget.select();
      }, { once: true });
    }
  }
}
